module.exports = __webpack_public_path__ + "static/media/tn.496dec8a.webp";